import { moveToFulfilled, moveToPending, moveToRejected, update } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type { GroupPublisherSettingsLoadAction } from '../../domains/groupPublisherSettings/actions.types';
import type { GroupCreateFulfilledAction, GroupEditFulfilledAction } from '../../domains/groups/actions.types';
import type { TypeaheadFulfilledAction } from '../../domains/typeahead/actions.types';

import type { GroupPublisherSettings } from './types';

export type GroupPublisherSettingAction =
  | GroupPublisherSettingsLoadAction
  | GroupCreateFulfilledAction
  | GroupEditFulfilledAction
  | TypeaheadFulfilledAction;

const initialState: GroupPublisherSettings = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

const reducer: Reducer<GroupPublisherSettings, GroupPublisherSettingAction> = (state = initialState, action) => {
  switch (action.type) {
    case 'PUBLISHER.LOAD_GROUP_PUBLISHER_SETTINGS_PENDING':
      return moveToPending(state, [action.payload.groupId]);
    case 'PUBLISHER.LOAD_GROUP_PUBLISHER_SETTINGS_REJECTED':
      return moveToRejected(state, [action.payload.groupId], action.payload.error);
    case 'PUBLISHER.LOAD_GROUP_PUBLISHER_SETTINGS_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groupPublisherSettings);
    case 'GROUP.EDIT_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groupPublisherSettings);
    case 'PUBLISHER.SETTING_SELECTED_SENDER_CHANGED': {
      const { groupId, selectedSenderId } = action.payload;

      return update(state, groupId, { selectedSenderId });
    }
    case 'TYPEAHEAD.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.groupPublisherSettings);
    default:
      return state;
  }
};

export default reducer;
